@if (isRouteMode) {
  <div class="tw-fixed tw-top-6 tw-left-4 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10 tw-z-20"
       (click)="back()">
    <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-50"
             [iconName]="'arrow_back'"></cs-icon>
  </div>
}
<div class="tw-bg-gray-100">
  <report id="skinReport"
          [regimen]="regimenData()"
          [isTimerPage]="true"
          [showRegimenToast]="showRegimenToast || showPreparationTimer"
          (showRegimenTimer)="showPreparationTimer = true"></report>
</div>
<div *ngIf="showRegimenToast"
     id="kitReady"
     class="tw-fixed w100 tw-bottom-0 tw-right-0 tw-flex tw-items-center font-noto tw-justify-between tw-px-4 tw-py-2 tw-z-[100] tw-h-20 tw-gap-4 tw-bg-[linear-gradient(92.61deg,#389987_7.51%,#56B8A6_68.14%)]"
     (click)="showRegimenPage(true)">
  <div class="tw-w-15 tw-h-15 tw-shrink-0 tw-bg-gray-50 tw-p-[2px] tw-rounded-full">
    <img class="tw-rounded-full tw-object-cover tw-w-full tw-h-full"
         [src]="regimenData()?.regimenCoverImage"
         alt="regimen"/>
  </div>
  <div class="tw-font-lexend tw-text-white tw-text-400 tw-font-bold"
       i18n="@@yourTreatmentKitIsReady">Your treatment kit is ready</div>
  <button csButton
          size="small"
          type="button">
    <span i18n="@@reportViewNow">View now</span>
    <cs-icon class="tw-h-4 tw-w-4"
             [iconName]='"chevron_right"'></cs-icon>
  </button>
</div>

<div *ngIf="!showRegimenToast && showPreparationTimer"
     class="tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-flex tw-flex-col tw-items-center tw-bg-yellow-100 tw-px-10 tw-pt-2 tw-pb-4 tw-z-[100] tw-h-20">
  <div class="tw-flex-none tw-relative tw-overflow-hidden tw-h-8 tw-w-full">
    @if (showDynamicTimerContent) {
      <div class="tw-absolute tw-left-0 tw-right-0 tw-text-center">
        <div [ngSwitch]="getCurrentMessageKey()" class="tw-h-8 tw-text-300 tw-text-gray-800 tw-font-body">
          <p *ngSwitchCase="TIMER_MESSAGE_KEYS.GETTING_TREATMENT_PLAN_READY" i18n="@@gettingTreatmentPlanReady">Getting your treatment plan ready...</p>
          <p *ngSwitchCase="TIMER_MESSAGE_KEYS.MATCHING_BEST_INGREDIENTS" i18n="@@matchingBestIngredients">Matching the best ingredients for you!</p>
          <p *ngSwitchCase="TIMER_MESSAGE_KEYS.FINDING_RIGHT_PRODUCTS" i18n="@@findingRightProducts">Finding the right products...</p>
          <p *ngSwitchCase="TIMER_MESSAGE_KEYS.ADDING_FACE_WASH" i18n="@@addingFaceWash">Adding face wash...</p>
          <p *ngSwitchCase="TIMER_MESSAGE_KEYS.ADDING_SUNSCREEN_MOISTURISER" i18n="@@addingSunscreenMoisturiser">Adding sunscreen & moisturiser...</p>
          <p *ngSwitchCase="TIMER_MESSAGE_KEYS.ADDING_REPAIR_FOR_CONCERN" i18n="@@addingRepairForConcern">Adding repair for your concern...</p>
          <p *ngSwitchCase="TIMER_MESSAGE_KEYS.FINDING_BEST_SUPPLEMENT" i18n="@@findingBestSupplement">Finding the best supplement...</p>
          <p *ngSwitchCase="TIMER_MESSAGE_KEYS.ALMOST_DONE" i18n="@@almostDone">Almost done!</p>
          <p *ngSwitchDefault i18n="@@gettingTreatmentPlanReady">Getting your treatment plan ready...</p>
        </div>
      </div>
    } @else {
      <div class="tw-animate-ticker_flip tw-absolute tw-left-0 tw-right-0 tw-text-center">
        <p class="tw-h-8 tw-text-300 tw-text-gray-800 tw-font-body"
           i18n="@@reviewReport">We are reviewing your report</p>
        <p class="tw-h-8 tw-text-300 tw-text-gray-800 tw-font-body"
           i18n="@@creatingKit">Creating your treatment kit</p>
      </div>
    }
  </div>
  <div class="tw-flex-auto tw-w-full">
    <div class="tw-flex tw-items-center tw-relative tw-rounded-full tw-h-6 tw-bg-repeat-x tw-bg-contain tw-animate-timer_progress_bg tw-overflow-hidden"
         style="background-image: url('/assets/images/background-arrow.png');">
      <div class="tw-rounded-l-full tw-h-full"
           style="animation-name: timer_progress_bar; animation-timing-function: linear; animation-fill-mode: forwards;"
           [ngStyle]="{'animation-duration': defaultTime + 'ms', 'animation-delay': elapsedTime + 'ms'}"></div>
      <div
        class="tw-absolute tw-left-0 tw-right-0 tw-top-0 tw-bottom-0 tw-flex tw-items-center tw-justify-center tw-font-bold tw-font-body tw-text-200 tw-text-gray-800">
        0{{timer.minutes}}:{{timer.seconds < 10
        ? '0'
        +
        timer.seconds
        :
        timer.seconds}}</div>
    </div>
  </div>
</div>
